export type FocusMode = "add" | "edit";
export type FocusState = "active" | "open" | "locked";

export type GuidedFocus = {
  mode: FocusMode;
  reached: number;
};

export function initialFocus(mode: FocusMode): GuidedFocus {
  return { mode, reached: 0 };
}

export function stateFor(focus: GuidedFocus, index: number, count: number): FocusState {
  if (focus.mode === "edit") return "open";
  const reached = Math.min(focus.reached, Math.max(count - 1, 0));
  if (index < reached) return "open";
  if (index === reached) return "active";
  return "locked";
}

export function advance(focus: GuidedFocus, count: number): GuidedFocus {
  if (focus.mode === "edit") return focus;
  return { ...focus, reached: Math.min(focus.reached + 1, Math.max(count - 1, 0)) };
}

/** Jump forward to a locked section (a click on the glass). Never moves back. */
export function reveal(focus: GuidedFocus, index: number): GuidedFocus {
  if (focus.mode === "edit") return focus;
  return { ...focus, reached: Math.max(focus.reached, index) };
}

/** The section list shrank (the moment changed): keep the position inside it. */
export function clampFocus(focus: GuidedFocus, count: number): GuidedFocus {
  if (focus.mode === "edit") return focus;
  return { ...focus, reached: Math.min(focus.reached, Math.max(count - 1, 0)) };
}

export function isComplete(focus: GuidedFocus, count: number): boolean {
  if (focus.mode === "edit") return true;
  return focus.reached >= count - 1;
}
